import * as React from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.background.default
      }
    }
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(3),
      width: '100%'
    },
    table: {}
  })
);

type IProps = {
  head: string[];
  rows: string[][];
};

const LieuucationTable: React.FC<IProps> = ({ head, rows }) => {
  const classes = useStyles();

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <TableContainer className={classes.root} component={Paper}>
      <Table
        className={classes.table}
        size={isSmall ? 'small' : 'medium'}
        aria-label="Micromarket comparison"
      >
        <TableHead>
          <TableRow>
            {head.map((e, i) => (
              <TableCell key={e} align={i === 0 ? 'left' : 'right'}>
                {e}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 &&
            rows.map((row, j) => (
              <StyledTableRow key={j}>
                {row.length > 0 &&
                  row.map((e, i) => (
                    <TableCell
                      key={i}
                      component={i === 0 ? 'th' : undefined}
                      scope={i === 0 ? 'row' : undefined}
                      align={i === 0 ? undefined : 'right'}
                    >
                      {e}
                    </TableCell>
                  ))}
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LieuucationTable;
